export default "__VITE_ASSET__bG7uyUqg__"